import { render, staticRenderFns } from "./productManagerCenter.vue?vue&type=template&id=7444860b&scoped=true"
import script from "./productManagerCenter.vue?vue&type=script&lang=js"
export * from "./productManagerCenter.vue?vue&type=script&lang=js"
import style0 from "./productManagerCenter.vue?vue&type=style&index=0&id=7444860b&prod&scoped=true&lang=css"
import style1 from "./productManagerCenter.vue?vue&type=style&index=1&id=7444860b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7444860b",
  null
  
)

export default component.exports